import React from "react";
import { useTranslation } from 'react-i18next';

function FactsAndStatsSection(props) {
    var { t, i18n } = useTranslation();

    return (
        <div>
            <section className="uk-section uk-section-muted uk-margin-large-top">
                <div className="uk-container">
                    <h2 className="uk-heading-medium uk-text-center">{props.sectionTitle}</h2>
                    <div className="uk-child-width-1-4@m uk-grid-large uk-text-center" data-uk-grid>
                        <div>
                            <h3 className="uk-heading-large uk-text-primary">{props.stat1}</h3>
                            <p>{props.fact1}</p>
                        </div>
                        <div>
                            <h3 className="uk-heading-large uk-text-primary">{props.stat2}</h3>
                            <p>{props.fact2}</p>
                        </div>
                        <div>
                            <h3 className="uk-heading-large uk-text-primary">{props.stat3}</h3>
                            <p>{props.fact3}</p>
                        </div>
                        <div>
                            <h3 className="uk-heading-large uk-text-primary">{props.stat4}</h3>
                            <p>{props.fact4}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default FactsAndStatsSection;